import { PortCategory } from "../../components/InputSearchWithPortOptions/types";

const SCHEDULE_PORT_CATEGORY_INFO_LIST: PortCategory[] = [
  { label: "항구", keyword: "sea" },
  { label: "공항", keyword: "air" },
];

export { SCHEDULE_PORT_CATEGORY_INFO_LIST };
